import React from 'react';
import {
  AttachmentCheckCircleAvatarIcon,
  AttachmentNotProvidedCircleAvatarIcon,
  AttachmentRequiredCircleAvatarIcon
} from '@/components/Icons';
import { IPurchaseTransaction } from '@/services/types/TransactionData';
import { isAttachmentRequired } from '../../utils/isReceiptRequired';
import cn from '@/utils/cn';

const SmallIconClass = 'w-2 h-2';
const BottomRightIconClass = cn(['w-3', 'h-3', 'rounded-full', 'absolute', 'bottom-0', 'right-0']);

export const getReceiptIcon = (purchaseTransactionData: IPurchaseTransaction) => {
  if (isAttachmentRequired(purchaseTransactionData)) {
    return {
      bottomRightContainerStyle: cn(BottomRightIconClass, 'bg-emerge-purple'),
      icon: (
        <AttachmentRequiredCircleAvatarIcon
          className={cn(SmallIconClass, 'text-emerge-purple-3')}
        />
      )
    };
  } else if (purchaseTransactionData.hasAttachments) {
    return {
      bottomRightContainerStyle: cn(BottomRightIconClass, 'bg-emerge-teal'),
      icon: <AttachmentCheckCircleAvatarIcon className={cn(SmallIconClass, 'text-emerge-navy')} />
    };
  } else if (purchaseTransactionData.receiptExemptionReason) {
    return {
      bottomRightContainerStyle: cn(BottomRightIconClass, 'bg-emerge-navy-4'),
      icon: (
        <AttachmentNotProvidedCircleAvatarIcon className={cn(SmallIconClass, 'text-aux-gray-3')} />
      )
    };
  }
};
